<span class="link" (click)="open()" [innerHTML]="link  | safe: 'html'"></span>
<div *ngIf="button" class="payout-button" (click)="open()">{{button}}</div>
<div #div class="d-none">
  <ng-content></ng-content>
</div>

